import React from "react";

const Footer = () => {
  return (
    <div className="mt-4">
      <hr />
      <ul className="text-black">
        <li>2024-he /him</li>
      </ul>
    </div>
  );
};

export default Footer;
